import React from "react"
import styles from "./styles.scss"
import Header, { TYPES, SEARCH_BAR } from "components/Header"
import Hero from "./Hero"
import About from "./About"
import Form from "./Form"
import Footer from "components/Footer"

class InfoPage extends React.Component {
  handleSubmit = values => {
    console.log(values)
  }
  render() {
    return (
      <div className={styles.container}>
        <Header
          headerType={TYPES.DARK_GRAY}
          searchBar={SEARCH_BAR.SHOW_SEARCH_BAR}
        />
        <Hero />

        {/*
        <About />
        <Form onSubmit={this.handleSubmit}/>
        */}

        <Footer />
      </div>
    )
  }
}

export default InfoPage



// WEBPACK FOOTER //
// src/pages/InfoPage/index.jsx